import { Button, Label, TextInput, Table, Select } from "flowbite-react";
import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSidebar } from "../../../context/SidebarOpenContext";
import Breadcrumb from "../../../hooks/Breadcrumb";
import { FaPlus } from "react-icons/fa";
import CustomSelect from "../../../hooks/CustomSelect";
import CustomSelectwithText from "../../../hooks/CustomSelectwithText";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";

function EditGroupBoxing() {
    const { user } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const orderid = searchParams.get("id");
    const bid = searchParams.get("bid");

    const navigate = useNavigate();
    const [Colour, setColour] = useState({});
    const url = localStorage.getItem("url");
    const [boxNoOptions, setBoxNoOptions] = useState([]);
    const [selectedBoxNo, setSelectedBoxNo] = useState("");
    const [date, setDate] = useState("");
    const [SizeVarientOptions, setSizeVarientOptions] = useState({});


    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {

        }
    }, [user, navigate]);


    const { isSidebarOpen } = useSidebar();

    useEffect(() => {
        if (orderid) {
            fetchboxlog();
            fetchBoxNos();
            fetchmarker();
            fetchColour();
        }
    }, [orderid]);

    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",

        },
        {
            href: `/boxing?id=${orderid}`,
            label: "Boxing",

        },
        {
            label: "Update Group Boxing",
        },

    ];

    const fetchboxlog = async () => {
        try {
            const response = await axios.get(`/group_boxing/group_boxing_by_logid/${bid}`);         
            setMiniBoxes(response.data.formated_mini_boxes);
            const logs = response.data.group_boxing_logs;
            if (logs && logs.length > 0) {
                const formatDate =  logs[0].date ? new Date(logs[0].date).toISOString().split("T")[0] : "";
                setDate(formatDate);
                setSelectedBoxNo(logs[0].box_no);
            }
    
        } catch (error) {
            console.error("Error fetching box log:", error);
        }
    };
    

    const fetchBoxNos = async () => {
        try {
            const response = await axios.get(`/group_boxing/box_no/${orderid}`);
           
            setBoxNoOptions(response.data.box_no || []);
        } catch (error) {
            console.error("Error fetching box numbers:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const requestData = {
            order_id: orderid,
            date: date,
            box_no: selectedBoxNo,
            staff_id: user.staff_id,
            minibox: miniBoxes,
            group_boxing_log_id:bid 
        };
        try {
            axios
                .put('group_boxing/group_boxing_by_logid', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Boxing Updated ",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });

                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }


                    navigate(`/boxing?id=${orderid}`);
                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const createBoxNo = async () => {
        try {
            const response = await axios.post(`/group_boxing/box_no/${orderid}`);
            const newBoxNo = response.data;
            setBoxNoOptions([...boxNoOptions, newBoxNo]);
            setSelectedBoxNo(newBoxNo);
        } catch (error) {
            console.error("Error creating box number:", error);
        }
    }

    const fetchmarker = async () => {
        try {
            const response = await axios.get(`/group_boxing/sizevarient_options/${orderid}`);
            const markerData = response.data.size_options;
            setSizeVarientOptions(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const fetchColour = async () => {
        try {
            const response = await axios.get(`/group_boxing/color_options/${orderid}`);
            const ColourData = response.data.color_options;

            const formattedColours = ColourData.map(colour => ({
                ...colour,
                imgSrc: colour.imgSrc ? `${url}${colour.imgSrc}` : null
            }));

            setColour(formattedColours);

        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const [miniBoxes, setMiniBoxes] = useState([
        { miniBoxNo: "", tables: [{ rows: [{ colour: null, selectedMarker: null }] }] }
    ]);

    // Handle Mini Box No. Input Change
    const handleMiniBoxNoChange = (index, value) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[index].miniBoxNo = value;
        setMiniBoxes(updatedBoxes);
    };

    // Add Mini Box
    const addMiniBox = () => {
        setMiniBoxes([...miniBoxes, { miniBoxNo: "", tables: [{ rows: [{ colour: null, selectedMarker: null }] }] }]);
    };

    // Delete Mini Box
    const deleteMiniBox = (miniBoxIndex) => {
        if (miniBoxes.length > 1) {
            setMiniBoxes(miniBoxes.filter((_, index) => index !== miniBoxIndex));
        }
    };

    // Add Table
    const addTable = (miniBoxIndex) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables.push({ rows: [{ colour: null, selectedMarker: null }] });
        setMiniBoxes(updatedBoxes);
    };

    // Delete Table
    const deleteTable = (miniBoxIndex, tableIndex) => {
        if (miniBoxes[miniBoxIndex].tables.length > 1) {
            const updatedBoxes = [...miniBoxes];
            updatedBoxes[miniBoxIndex].tables.splice(tableIndex, 1);
            setMiniBoxes(updatedBoxes);
        }
    };

    // Add Row
    const addRow = (miniBoxIndex, tableIndex) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows.push({ colour: null, selectedMarker: null });
        setMiniBoxes(updatedBoxes);
    };

    // Delete Row
    const deleteRow = (miniBoxIndex, tableIndex, rowIndex) => {
        if (miniBoxes[miniBoxIndex].tables[tableIndex].rows.length > 1) {
            const updatedBoxes = [...miniBoxes];
            updatedBoxes[miniBoxIndex].tables[tableIndex].rows.splice(rowIndex, 1);
            setMiniBoxes(updatedBoxes);
        }
    };

    // Handle Colour Change
    const handleColourChange = (miniBoxIndex, tableIndex, rowIndex, selectedOptions) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows[rowIndex].colour = selectedOptions;
        setMiniBoxes(updatedBoxes);
    };

    // Handle Marker Change
    const handleMarkerChange = (miniBoxIndex, tableIndex, rowIndex, selectedOptions) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows[rowIndex].selectedMarker = selectedOptions;
        setMiniBoxes(updatedBoxes);
    };

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14  h-full">
                <div className="p-4 rounded-lg shadow bg-white ">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <div className=" flex items-center pt-4">
                            <h3 className="text-lg font-medium text-sidebar-color dark:text-white mr-2">
                                Update Group Boxing
                            </h3>
                            <Button className="bg-sidebar-color text-white" size="xs" onClick={(e) => {
                                e.preventDefault();
                                addMiniBox();
                            }}> Add Mini Box</Button>
                        </div>
                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <div className="mb-2 block  ">
                                    <Label htmlFor="password" value="Date" />
                                </div>
                                <TextInput
                                    name="orderdate"
                                    type="date"
                                    value={date}
                                    required
                                    autoComplete="off"
                                    onChange={(e) => setDate(e.target.value)}
                                />
                            </div>
                            <div className="w-1/2">
                                <div className="mb-2 block">
                                    <Label htmlFor="boxNo" value="Box No" />
                                </div>
                                <div className="flex items-center space-x-2">
                                    {/* <TextInput className='w-full' name="box_no" type="text" required value={selectedBoxNo} onChange={(e) => setSelectedBoxNo(e.target.value)} disabled /> */}
                                    <Select
                                        className='w-full'
                                        name="box_no"
                                        value={selectedBoxNo}
                                        onChange={(e) => setSelectedBoxNo(e.target.value)}
                                        required
                                    >
                                        <option value="">Select Box No</option>
                                        {boxNoOptions.length > 0 ? (
                                            boxNoOptions.map((box, index) => (
                                                <option key={index} value={box}>{box}</option>
                                            ))
                                        ) : (
                                            <option disabled>No boxes available</option>
                                        )}
                                    </Select>
                                    <Button size="xs" className='pt-1 pb-1' color="blue" onClick={createBoxNo} >
                                        <FaPlus />
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <div>

                            {miniBoxes.map((miniBox, miniBoxIndex) => (
                                <div key={miniBoxIndex} className="border p-4 mb-6 rounded-lg shadow-md relative">
                                    {/* Mini Box Header */}
                                    <div className="flex justify-between items-center">
                                        <div className="w-1/2">
                                            <div className="mb-2 flex items-center">
                                                <Label htmlFor="minibox" value="Mini Box No" />
                                                <Button className="ml-2 bg-sidebar-color text-white" size="xs" onClick={() => addTable(miniBoxIndex)}>
                                                    Add Assortment
                                                </Button>
                                            </div>
                                            <TextInput
                                                name="miniboxNo"
                                                type="text"
                                                required
                                                autoComplete="off"
                                                value={miniBox.miniBoxNo}
                                                onChange={(e) => handleMiniBoxNoChange(miniBoxIndex, e.target.value)}
                                            />
                                        </div>

                                        {miniBoxes.length > 1 && (
                                            <IoMdClose
                                                size={24}
                                                className="text-red-500 cursor-pointer"
                                                onClick={() => deleteMiniBox(miniBoxIndex)}
                                            />
                                        )}
                                    </div>


                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        {miniBox.tables.map((table, tableIndex) => (
                                            <div key={tableIndex} className="mt-4 p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">
                                                {/* Table Header */}
                                                <div className="flex justify-between items-center">
                                                    <div className="flex items-center">
                                                        <h4 className="text-md font-medium">Assortment {tableIndex + 1}</h4>
                                                        <Button
                                                            className="ml-2 bg-sidebar-color text-white"
                                                            size="xs"
                                                            onClick={() => addRow(miniBoxIndex, tableIndex)}
                                                        >
                                                            Add Row
                                                        </Button>
                                                    </div>
                                                    {miniBox.tables.length > 1 && (
                                                        <IoMdClose
                                                            size={24}
                                                            className="text-red-500 cursor-pointer"
                                                            onClick={() => deleteTable(miniBoxIndex, tableIndex)}
                                                        />
                                                    )}
                                                </div>
                                                {/* Assortment Grid (3 in a row) */}
                                                {table.rows.map((row, rowIndex) => (
                                                    <div key={rowIndex} className="border p-3 flex flex-col gap-2 m-2 ">
                                                        {table.rows.length > 1 && (
                                                            <IoMdClose
                                                                size={24}
                                                                className="text-red-500 cursor-pointer self-end"
                                                                onClick={() => deleteRow(miniBoxIndex, tableIndex, rowIndex)}
                                                            />
                                                        )}
                                                        {/* Colour Selection */}
                                                        <CustomSelect
                                                            value={row.colour}
                                                            onChange={(selectedOptions) =>
                                                                handleColourChange(miniBoxIndex, tableIndex, rowIndex, selectedOptions)
                                                            }
                                                            options={Colour.length > 0 ? Colour : []}
                                                            placeholder="Select a colour"
                                                        />

                                                        {/* Marker Selection */}
                                                        <CustomSelectwithText
                                                            value={row.selectedMarker}
                                                            onChange={(selectedOptions) =>
                                                                handleMarkerChange(miniBoxIndex, tableIndex, rowIndex, selectedOptions)
                                                            }
                                                            options={SizeVarientOptions.length > 0 ? SizeVarientOptions : []}
                                                        />

                                                        {/* Delete Row Button */}

                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            <div className="flex justify-center gap-4 pt-4">
                                <Button
                                    className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                                    type="button"
                                    onClick={handleSubmit}
                                >
                                    {"Submit"}
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditGroupBoxing;
